<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        },
    },
    data: () => ({
        acompanhamentoOci: null,
        items: [],
    }),
    methods: {
        open(item) {

            this.acompanhamentoOci = item

            this.items = [
                {
                    field: 'Profissional solicitante',
                    value: item.usuarioSolicitanteNome,
                },
                {
                    field: 'CBO solicitante',
                    value: item.usuarioSolicitanteOcupacaoDescricao,
                },
                {
                    field: 'CID',
                    value: item.cidDescricao,
                },
                {
                    field: 'CIAP',
                    value: item.ciapDescricao,
                },
                {
                    field: 'Justificativa',
                    value: item.justificativa,
                },
                {
                    field: 'Observação',
                    value: item.observacao,
                },
            ]

            this.$refs.Modal.show()
        },
    },
}
</script>